import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import PartnerTable from '../PartnerTable'
import { GetPartnerDataResponse } from '@/modules/manage-player/type'

interface PartnerListingProps {
	data: GetPartnerDataResponse[]
	total: number
	isLoading?: boolean
}

export default function PartnerListing({
	data,
	total,
	isLoading,
}: PartnerListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`รายชื่อพาร์ทเนอร์ทั้งหมด`}
					description="รายชื่อพาร์ทเนอร์ทั้งหมด"
				/>
			</div>
			<Separator />
			<PartnerTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
